export default {
  data() {
    return {
      ecotronHeaders: [
        { text: 'Timestamp', value: 'createdAt', sortable: true },
        {
          text: 'Table Number',
          value: 'TBN',
          sortable: false
        },
        {
          text: 'DC current',
          value: 'DCI',
          sortable: false
        },
        {
          text: 'DC bus voltage',
          value: 'DCV',
          sortable: false
        },
        {
          text: 'Output power',
          value: 'OPW',
          sortable: false
        },
        {
          text: 'Frequency',
          value: 'OPF',
          sortable: false
        },
        {
          text: 'Load current',
          value: 'OPC',
          sortable: false
        },
        {
          text: 'File size',
          value: 'FILE_SIZE',
          sortable: false
        },
        {
          text: 'Board temperature',
          value: 'BTP',
          sortable: false
        },
        {
          text: 'IGBT core temperature',
          value: 'ITP',
          sortable: false
        },
        {
          text: 'Fault code',
          value: 'IFLT',
          sortable: false
        },
        {
          text: 'Binary status',
          value: 'BIN_STATUS',
          sortable: false
        },
        {
          text: 'Real time clock',
          value: 'INT_TIME',
          sortable: false
        },
        {
          text: 'Internal RTC',
          value: 'INT_RTC',
          sortable: false
        },
        {
          text: 'Signal strength',
          value: 'SNG',
          sortable: false
        },
        {
          text: 'Energy input',
          value: 'ENERGY_IN',
          sortable: false
        },
        {
          text: 'System uptime',
          value: 'SYS_UPTIME',
          sortable: false
        },
        {
          text: 'Drive Up Time',
          value: 'TMS_UP',
          sortable: false
        },
        {
          text: 'Fault register 1',
          value: 'FL1',
          sortable: false
        },
        {
          text: 'Fault register 2',
          value: 'FL2',
          sortable: false
        },
        {
          text: 'Fault register 3',
          value: 'FL3',
          sortable: false
        },
        {
          text: 'Alarm register 1',
          value: 'AR1',
          sortable: false
        },
        {
          text: 'Alarm register 2',
          value: 'AR2',
          sortable: false
        },
        {
          text: 'APN',
          value: 'APN',
          sortable: false
        },
        {
          text: 'Dry-run frequency',
          value: 'DR_FRQ',
          sortable: false
        },
        {
          text: 'Dry-run power',
          value: 'DR_POW',
          sortable: false
        },
        {
          text: 'Datalog interval',
          value: 'LOG_INT',
          sortable: false
        },
        {
          text: 'Lattitude',
          value: 'LATT',
          sortable: false
        },
        {
          text: 'Longitude',
          value: 'LONG',
          sortable: false
        },
        {
          text: 'Ecotron application software version',
          value: 'ET_SWV',
          sortable: false
        },
        {
          text: 'Ecotron model number',
          value: 'ET_MODEL',
          sortable: false
        },
        {
          text: 'Telecom Service Provider',
          value: 'TSP',
          sortable: false
        },
        {
          text: 'Quectel OpenCPU Software Version',
          value: 'M66_OCV',
          sortable: false
        },
        {
          text: 'Quectel Base Software Version',
          value: 'M66_BSV',
          sortable: false
        },
        {
          text: 'SIM ICCID',
          value: 'ICCID',
          sortable: false
        },
        {
          text: 'IMEI',
          value: 'IMEI',
          sortable: false
        },
        {
          text: 'Solar Drive Firmware Version',
          value: 'DRIVE_FW',
          sortable: false
        },
        {
          text: 'Drive Kernel Verion',
          value: 'EKV',
          sortable: false
        }
      ]
    };
  }
};
